//공지관련 함수들은 대부분 미완성된 상태입니다.
// 추후에 공지 관련 로직이 완성되면 수정해야 합니다.
//2025.04.07. 김병현

import axios from 'axios';
import * as Sentry from '@sentry/vue';
import { authApi } from '../utils/api';

const logs = {
  namespaced: true,
  state: {
    activity_logs: [],
    activity_logs_loaded: false,
    mention_list: [],
    new_notice: 0
  },
  mutations: {
    add_activity_logs(state, new_log_list) {
      state.activity_logs = new_log_list;
    },
    update_activity_logs_loaded(state, flag) {
      state.activity_logs_loaded = flag;
    },
    update_mention_list(state, new_list) {
      state.mention_list = new_list;
    },
    update_notice_read(state, { notice_id, code }) {
      const copy_list = [...state.mention_list];
      const idx = copy_list.findIndex(item => item.id == notice_id || item.notice_id == notice_id);
      if (code && idx > -1) {
        copy_list[idx].has_read = true;
      } else if (!code && idx > -1) {
        copy_list[idx].has_read = false;
      } else {
        console.log('code확인 필요');
      }
      state.mention_list = copy_list;
    },

    update_new_notice(state) {
      let new_count = 0;
      const copy_list = [...state.mention_list];
      copy_list.forEach(item => (item.has_read == false ? (new_count += 1) : new_count));
      state.new_notice = new_count;
    }
  },
  getters: {
    unread_mentions(state) {
      return state.mention_list.filter(m => !m.has_read);
    },
    read_mentions(state) {
      return state.mention_list.filter(m => m.has_read);
    }
  },
  actions: {
    read_logs_report_code({ commit, rootState }, { report_codes }) {
      // report_code를 배열 형태로 받음
      const path = rootState.backend_host + '/read_logs';
      const promises = [];
      report_codes.forEach(item => {
        promises.push(
          axios.get(path, {
            params: {
              report_code: item
            }
          })
        );
      });
      return Promise.all(promises)
        .then(responses => {
          const new_log_list = [];
          const temp_result = responses;
          for (let i = 0; i < temp_result.length; i++) {
            temp_result[i].data.forEach(x => new_log_list.push(x));
          }
          new_log_list.sort((a, b) => parseFloat(b.time_stamp) - parseFloat(a.time_stamp));
          commit('add_activity_logs', new_log_list);
          commit('update_activity_logs_loaded', true);
        })
        .finally(() => {});
    },

    async readNoticesByUser({ commit, rootState }, { user_email }) {
      /**
       * TODO : 공지 로직이 완성되면 사용
       */
      let temp_list = [];

      try {
        const response = await authApi.get('/read_notices_by_user', {
          params: { user_email: user_email }
        });

        if (response.data) {
          temp_list = response.data;
          commit('update_new_notice');
        }
      } catch (error) {
        error.message = '[공지 읽기]' + error.message;
        Sentry.captureException(error);
      }
      commit('update_mention_list', temp_list);
    },

    makeNoticeRead({ commit, rootState }, { notice_id, user_id, has_read }) {
      const path = rootState.backend_host + '/make_notice_read';
      const formData = new FormData();
      formData.append('notice_id', notice_id);
      formData.append('user_id', user_id);
      formData.append('has_read', has_read.toString());
      return axios
        .post(path, formData)
        .then(response => {
          const code = response.data.code;
          commit('update_notice_read', { notice_id: notice_id, code: code });
          commit('update_new_notice');
        })
        .catch(error => {
          error.message = '[공지 확인]' + error.message;
          Sentry.captureException(error);
        });
    },

    async saveNotice({ commit, rootState }, noticeData) {
      const path = rootState.backend_host + '/notice';
      // 모든 사용자에게 보낼 경우 noticeData.target_emails을 빈 배열로 보냅니다.
      try {
        const response = await axios.post(path, {
          title: noticeData.title,
          content: noticeData.content,
          sender_email: noticeData.sender_email,
          target_emails: noticeData.target_emails
        });
        if (response) {
          console.log(response.data);
        }
      } catch (error) {
        error.message = '[공지 저장]' + error.message;
        Sentry.captureException(error);
        throw error;
      }
    },

    async requestEditFromSbDisclosures({ commit, rootState }, noticeData) {
      const path = rootState.backend_host + '/notice/storyboard/status';
      // 모든 사용자에게 보낼 경우 noticeData.target_emails을 빈 배열로 보냅니다.
      try {
        const response = await axios.post(path, {
          title: noticeData.title,
          content: noticeData.content,
          sender_email: noticeData.sender_email,
          report_code: noticeData.report_code,
          lv2_key: noticeData.lv2_key
        });
        if (response) {
          console.log(response.data);
        }
      } catch (error) {
        error.message = '[공지 저장]' + error.message;
        Sentry.captureException(error);
        throw error;
      }
    },
    deleteMentionFromList({ commit, state }, { id }) {
      const filteredList = state.mention_list.filter(item => item.id !== id);
      commit('update_mention_list', filteredList);
      commit('update_new_notice');
    }
  }
};
export default logs;
